import * as yup from '@if/core/yup'
import {
  ControlledSearchField,
  ControlledToggleButtonGroup,
  FormContainer,
  useTranslatedToggleButtonOptionEnum,
} from '@if/mui'
import { Grid } from '@mui/material'
import { ESystemMatchingResult, getESystemMatchingResultList, InteracWireFiltersType } from '@src/types/interac'
import { useTranslation } from 'react-i18next'

const schema = yup.object({
  search: yup.text(),
  systemMatchingResult: yup
    .mixed<ESystemMatchingResult>()
    .oneOf(getESystemMatchingResultList())
    .required()
    .default(ESystemMatchingResult.Sure),
})

export type InteracQueueFilterValues = yup.InferSubmit<typeof schema>

interface InteracQueueFiltersProps {
  filters: InteracWireFiltersType
  onChange: (values: InteracQueueFilterValues) => void
}

const InteracQueueFilters = ({ filters, onChange }: InteracQueueFiltersProps) => {
  const { t } = useTranslation()
  const matchResultOptions = useTranslatedToggleButtonOptionEnum(
    'enum.systemMatchingResult',
    getESystemMatchingResultList(),
  )

  return (
    <FormContainer
      mode="filters"
      useFormSetup={() => ({
        schema,
        defaultValues: {
          search: filters.email ?? filters.clientNameContains,
          systemMatchingResult: filters.systemMatchingResult,
        },
      })}
      onSubmit={onChange}
    >
      {({ control }) => (
        <Grid container spacing={1}>
          <Grid size={{ xs: 12, md: 7, lg: 12 }}>
            <ControlledSearchField
              control={control}
              name="search"
              placeholder={t('interacWire.queue.searchPlaceholder')}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 5, lg: 12 }}>
            <ControlledToggleButtonGroup
              control={control}
              name="systemMatchingResult"
              exclusive
              required
              size="small"
              color="primary"
              fullWidth
              options={matchResultOptions}
            />
          </Grid>
        </Grid>
      )}
    </FormContainer>
  )
}

export default InteracQueueFilters
